import { useQuery } from "react-query";

import { WorkOrder } from "../../models";
import { getAll } from "../../api/generic-api";
import { RQ } from "../../globals/enums";

export const useWorkOrdersSearch = (searchTerm: string) => {
  return useQuery<WorkOrder[], Error>(
    [RQ.WORK_ORDERS_SEARCH, searchTerm],
    () => getAll(`work-orders/search?searchTerm=${searchTerm}`),
    {
      enabled: Boolean(searchTerm),
    }
  );
};
